// import sysend from "sysend";
import {BroadcastChannel} from "broadcast-channel";

const swchannel = new BroadcastChannel("prasora");
const id = Date.now();

// export default {
// 	send: (trigger, data) => {
// 		console.log("sending message", trigger, data);
// 		swchannel.postMessage({trigger, data});
// 	},
// 	// receive: (func) => {
// 	// 	swchannel.onmessage = (data) => {
// 	// 		// console.log("recieved message", data, func);
// 	// 		if (func) func(data);
// 	// 	};
// 	// },
// 	listen: async (trigger) => {
// 		return new Promise((resolve) => {
// 			swchannel.onmessage = (data) => {
// 				if (data.trigger == trigger) {
// 					resolve(data.data);
// 				}
// 			};
// 		});
// 	},
// 	ask: async (triggerup, triggerdown, data, reference) => {
// 		// console.log("msg reference:", reference);
// 		return new Promise((resolve) => {
// 			swchannel.onmessage = (data) => {
// 				if (data.trigger == triggerdown && !data.sent) {
// 					data = data.data;
// 					resolve(data);
// 				}
// 			};
// 			swchannel.postMessage({trigger: triggerup, data, sent: true});
// 		});
// 	},
// };

const unresolvedpromises = {};
const listeningfuncs = {};
swchannel.onmessage = (data) => {
	resolvepromises(data);
};

function resolvepromises(data) {
	// console.log("received", data, unresolvedpromises);
	if (data.trigger) {
		let promises = unresolvedpromises[data.trigger];
		let funcs = listeningfuncs[data.trigger];

		// console.log("ok", {promises, funcs});

		if (promises) {
			promises.forEach((resolve) => {
				resolve(data.data);
			});
			unresolvedpromises[data.trigger] = [];
		}

		if (funcs) {
			funcs.forEach((func) => func(data));
		}
	}
}

export default {
	send: (trigger, data) => {
		swchannel.postMessage({trigger, data});
	},
	listen: (trigger, func) => {
		if (!func) console.log("error in listening", trigger);
		if (!listeningfuncs[trigger]) listeningfuncs[trigger] = [];
		listeningfuncs[trigger].push(func);
	},
	ask: async (triggerup, triggerdown, data, reference) => {
		let promise = new Promise((resolve) => {
			if (!unresolvedpromises[triggerdown]) {
				unresolvedpromises[triggerdown] = [];
			}
			unresolvedpromises[triggerdown].push(resolve);
		});
		swchannel.postMessage({triggerup, data});
		return promise;
	},
};

//  methods;
